import React from 'react';
import Header from '../Header/Header';

const Blog = () => {
    return (
        <div>
        </div>
    );
};

export default Blog;